import React, { createContext, useReducer } from "react";
import Reducer from './Reducer'
import AsyncStorage from '@react-native-async-storage/async-storage';
import useMounted from "../../hooks/useMounted";
import http from "../../utils/http";

const initialState = {
    feeds: [],
    error: null
};

const Store = ({ children }) => {
    const [state, dispatch] = useReducer(Reducer, initialState);
    const isMounted = useMounted();
    
    const fetch = async () => {
        const do_dispatch = (obj) => {
            isMounted.current && dispatch(obj)
        }

        const buyerData = await AsyncStorage.getItem('buyerData')
        const feedData = await AsyncStorage.getItem('promoList')

        const store = {
            token: await AsyncStorage.getItem('userToken'),
            buyer: await AsyncStorage.getItem('buyerId'),
            buyerData: JSON.parse(buyerData),
            feedData: JSON.parse(feedData),
        }

        do_dispatch({ type: 'SET_FEEDS', payload: store.feedData });

        return new Promise((resolve, reject) => {

            let formData = new FormData()
            formData.append('buyer_id', store.buyer)

            http.post(
                "feed/show_valid/",
                formData,
                store.token
            ).then(data => {
                if (data.code === 200) {
                    AsyncStorage.setItem('promoList', JSON.stringify(data.data));
                    do_dispatch({ type: 'SET_FEEDS', payload: data.data });
                    resolve(data.data)
                } else {
                    do_dispatch({ type: 'SET_ERROR', payload: data.message });
                    reject()
                    console.log(data.message)
                }
            })

        })
    }

    return (
        <Context.Provider value={[state, dispatch, fetch]}>
            {children}
        </Context.Provider>
    )
};

export const Context = createContext(initialState);
export default Store;